var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger js-burger"},[_c('span',{staticClass:"burger__bar burger__bar1"}),_c('span',{staticClass:"burger__bar burger__bar2"}),_c('span',{staticClass:"burger__bar burger__bar3"}),_c('span',{staticClass:"burger__bar burger__bar4"}),_c('span',{staticClass:"burger__bar burger__bar5"})])
}]

export { render, staticRenderFns }